import "core-js/modules/es6.string.link";
import "core-js/modules/es6.typed.uint8-array";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es7.array.includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { uuid } from '@/util/utils';
import baseList from '@/option/base';
import { updateComponent } from '@/api/bigscreen/visual';
export default {
  inject: ["contain"],
  data: function data() {
    return {
      baseList: baseList
    };
  },
  methods: {
    vaildData: function vaildData(id) {
      var list = [];

      for (var i = 0; i < 20; i++) {
        list.push(i + '');
      }

      return list.includes(id);
    },
    handleView: function handleView() {
      this.contain.menuFlag = false;
      this.contain.handleInitActive(); // this.contain.setScale(document.body.clientWidth);
    },
    handleReset: function handleReset() {
      this.contain.menuFlag = true;
      this.contain.setScale(this.contain.contentWidth);
    },
    handleBuild: function handleBuild() {
      var _this = this;

      this.contain.handleInitActive();
      var loading = this.$loading({
        lock: true,
        text: '正在保存配置，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$nextTick(function () {
        html2canvas(document.getElementById('content'), {
          useCORS: true,
          backgroundColor: null,
          allowTaint: true
        }).then(function (canvas) {
          function dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);

            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }

            return new File([u8arr], filename, {
              type: mime
            });
          }

          var file = dataURLtoFile(canvas.toDataURL('image/jpeg', 0.1), new Date().getTime() + '.jpg');
          var formdata = new FormData();
          formdata.append('file', file);
          axios.post(_this.url + '/visual/put-file', formdata, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }).then(function (res) {
            var data = res.data.data;
            var url = data.link;
            var formdata = {
              visual: {
                id: _this.contain.visual.id,
                backgroundUrl: url
              },
              config: {
                id: _this.contain.obj.config.id,
                visualId: _this.contain.visual.id,
                detail: JSON.stringify(_this.contain.config),
                component: JSON.stringify(_this.contain.nav)
              }
            };
            return updateComponent(formdata);
          }).then(function () {
            loading.close();

            _this.$confirm('保存成功大屏配置, 是否打开预览?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              var routeUrl = _this.$router.resolve({
                path: '/view/' + _this.contain.id
              });

              window.open(routeUrl.href, '_blank');
            }).catch(function () {});
          }).catch(function () {
            _this.$message.error('模版例子不能修改');

            loading.close();
          });
        });
      });
    },
    handleAdd: function handleAdd(option) {
      var first = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var obj = this.deepClone(option);
      obj.left = 0;
      obj.top = 0;
      obj.index = uuid();

      if (first) {
        this.contain.nav.unshift(obj);
      } else {
        this.contain.nav.push(obj);
      }
    }
  }
};